// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2db8a58d","309":"cc74efdb","407":"0223a5e2","491":"f142edab","558":"6683c55f","685":"85dcdaf0","719":"f0b55526","720":"cb6d6447","729":"7ad9ab7d","748":"a429c54c","818":"32f82ee6","843":"159732ec","866":"f3e39bcc"}[chunkId] + ".chunk.js";
};